module.exports = __webpack_public_path__ + "img/tza.d43d75f1.svg";